module.exports = __webpack_public_path__ + "img/safebuilding.41323bc7.svg";